import React from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  PopoverBody,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledPopover,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";

import uuid from "uuid";
import "./Participents.less";
import { slide as Menu } from "react-burger-menu";
import { isIE } from 'react-device-detect';
import { getMessage } from "CONFIG/i18n";

import ic_attendee from "ASSETS/Images/waiting_area/ic_attendee.svg";
import ic_attendee_presenter from "ASSETS/Images/waiting_area/ic_attendee_presenter.svg";
import ic_host from "ASSETS/Images/waiting_area/ic_host.svg";
import ic_host_presenter from "ASSETS/Images/waiting_area/ic_host_presenter.svg";
// import ic_close from "ASSETS/Images/header_right/ic_close.svg";

// Constants
import { PARTICIPANT_LIMIT_SM, PARTICIPANT_LIMIT_LG, USER_ROLES, USER_STATIC } from "UTILS/Constants";

import { getUserNameForSelectedLanguage, getUserNameAcronym } from "UTILS/Utility";

function Participants(props) {
  let makePresenter = participant => {
    props.makePresenter(participant);
  };
  let addInviteeHandle = () => {
    props.openDrawer();
    props.addInviteeHandle();
  };
  let handleEndSession = () => {
    props.handleCancelClick();
    props.onOpenCloseEndSessionConfirmationModal(true);
  };
  let handleLeaveSession = () => {
    props.handleCancelClick();
    props.onOpenCloseLeaveSessionConfirmationModal(true);
  };
  const [selectParticipantIndex, setSelectParticipantIndex] = React.useState(0)
  const selectSnapchotParticipant = () => {
    props.sendTakeSnapshotMessage(props.participants[selectParticipantIndex].uniqueId);
    props.handleStartClick();
  }

  if (!props.mobileView) {
    let PARTICIPANT_LIMIT = window.innerWidth >= 1215
      ? PARTICIPANT_LIMIT_LG
      : PARTICIPANT_LIMIT_SM

    let limit = props.participants.length > PARTICIPANT_LIMIT 
      ? PARTICIPANT_LIMIT-1
      : props.participants.length
    let moreParticipants = props.participants.length > PARTICIPANT_LIMIT 
    let participantList = _.cloneDeep(props.participants);
    let moreParticipantsList = _.cloneDeep(props.participants);
    // let limit = props.participants.length > 3 ? 2 : 
    return (
      <React.Fragment>
        {participantList.slice(0,limit).map(participant => {
          let presenterCSS = props.presenter === participant.uniqueId
            ? "displayFlex alignItemsCenter justifyContentFlexCenter presenter-card-text participants positionRelative"
            : "displayFlex alignItemsCenter justifyContentFlexCenter card-text participants positionRelative"
          return participant ? (
            <div key={uuid.v4()}>
              <div
                id={"participantId" + participant.participantId}
                className={
                  props.uniqueId === props.organiser && participant.uniqueId !== props.presenter ? 
                    "blinkImg cursorPointer " + presenterCSS 
                    : "" + presenterCSS 
                }
                onClick={() => props.showMakePresenter(participant.participantId)}
              >
                <label
                  className={
                    props.uniqueId === props.organiser && participant.uniqueId !== props.presenter 
                      ? "cursorPointer" 
                      : ""
                  }
                  title={participant.userName}
                >
                  {getUserNameAcronym(participant.userName)}
                </label>
                {(props.presenter === participant.uniqueId)?<span className="badge">P</span>:null}
              </div>
              {(props.presenter !== participant.uniqueId && props.isAgent) && (
                <UncontrolledPopover
                  placement="bottom"
                  isOpen={
                    props.makePresenterPopoverOpen === participant.participantId
                  }
                  target={"participantId" + participant.participantId}
                  toggle={() =>
                    props.showMakePresenter(participant.participantId)
                  }
                  trigger="legacy"
                >
                  <PopoverBody
                    className="displayFlex cursorPointer blinkImg"
                    onClick={() => makePresenter(participant)}
                  >
                    {/* <img src={ic_make_presenter} className="pl-2 pr-2" /> */}
                    <span>{getMessage("MAKE_PRESENTER")}</span>
                  </PopoverBody>
                </UncontrolledPopover>
              )}
            </div>
          ) : null;
        })}
        {moreParticipants && 
        <React.Fragment>
          <Dropdown
            placement="bottom"
            isOpen={props.moreParticipantsPopOver}
            toggle={() => {}}
            className="moreParticipants"
            onClick={() => {
              isIE ? props.showMoreParticipants() : null 
              if(props.makePresenterPopoverOpen)
                props.showMakePresenter(null)
            }}
          >
            <DropdownToggle
              tag="div"
            >
              <div
                className="blinkImg cursorPointer displayFlex alignItemsCenter justifyContentFlexCenter card-text participants positionRelative"
                onClick={() => !isIE ? props.showMoreParticipants() : null }
                id="moreParticipants"
              >
                <label
                  className={
                    "cursorPointer" 
                  }
                  title={getMessage("MORE_PARTICIPANTS")}
                >
                  +{props.participants.length-(PARTICIPANT_LIMIT-1)}
                </label>
              </div>
            </DropdownToggle>

            <DropdownMenu 
              toggle={false}
              className={isIE 
                ? moreParticipantsList.slice(limit,moreParticipantsList.length).length == 2
                  ? "minWidth2"
                  : "minWidth4"
                : ""
              }>
              {moreParticipantsList.slice(limit,moreParticipantsList.length).map((participant,index) => {
                let presenterCSS = props.presenter === participant.uniqueId
                  ? "displayFlex alignItemsCenter justifyContentFlexCenter presenter-card-text participants positionRelative"
                  : "displayFlex alignItemsCenter justifyContentFlexCenter card-text participants positionRelative"
                // let gridColumn = "column"+((index%3)+1)
                // let gridRow = parseInt(index/3)
                return participant ? (
                  <DropdownItem
                    tag="div"
                  >
                    <div
                      id={"participantId" + participant.participantId}
                      className={
                        props.uniqueId === props.organiser && participant.uniqueId !== props.presenter ? 
                          "blinkImg cursorPointer " + presenterCSS 
                          : "" + presenterCSS 
                      }
                      onClick={(event) => { 
                        event.stopPropagation();
                        props.showMakePresenter(participant.participantId)}
                      }
                    >
                      <label
                        className={
                          props.uniqueId === props.organiser && participant.uniqueId !== props.presenter 
                            ? "cursorPointer" 
                            : ""
                        }
                        title={participant.userName}
                      >
                        {getUserNameAcronym(participant.userName)}
                      </label>
                      {(props.presenter === participant.uniqueId)?<span className="badge">P</span>:null}
                    </div>
                    {(props.presenter !== participant.uniqueId && props.isAgent) && (
                      <UncontrolledPopover
                        placement="bottom"
                        isOpen={
                          props.makePresenterPopoverOpen === participant.participantId
                        }
                        target={"participantId" + participant.participantId}
                        toggle={() =>
                          props.showMakePresenter(participant.participantId)
                        }
                        trigger="legacy"
                      >
                        <PopoverBody
                          className="displayFlex cursorPointer blinkImg"
                          onClick={() => makePresenter(participant)}
                        >
                          {/* <img src={ic_make_presenter} className="pl-2 pr-2" /> */}
                          <span>{getMessage("MAKE_PRESENTER")}</span>
                        </PopoverBody>
                      </UncontrolledPopover>
                    )}
                  </DropdownItem>
                ) : null;
              })}
            </DropdownMenu>
          </Dropdown>
        </React.Fragment>
        }
      </React.Fragment>
    )
  } else if (props.isSnapshot === true) {
    return (
      <Modal isOpen={props.show} className="snapshotParticipantModal" backdrop="static">
        <ModalHeader className="popupHeader text-center">
          {getMessage("SELECT_PARTICIPANT_TO_TAKE_SNAPSHOT")}
        </ModalHeader>
        <ModalBody>
          <div className="flexContainer">
            {props.organiser === props.uniqueId &&
              props.participants.map((participant, index) => {
                const isPresenter = participant.uniqueId === props.presenter;
                let userIcon = participant.role === USER_ROLES.AGENT && isPresenter
                  ? ic_host_presenter
                  : participant.role === USER_ROLES.AGENT && !isPresenter
                    ? ic_host
                    : participant.role === USER_ROLES.USER && isPresenter
                      ? ic_attendee_presenter
                      : ic_attendee;
                let participantName = participant.role === USER_ROLES.AGENT
                  ? getUserNameForSelectedLanguage(props.language, participant.userName)
                  : participant.userName;
                let user = USER_ROLES.AGENT && isPresenter ? participantName : USER_STATIC.GUEST;
                return participant ? (
                  <Row className="userListItem"
                    onClick={()=>setSelectParticipantIndex(index)}
                    key={`userListItem${index}`}
                  >
                    <Col lg="auto" className="noPadding radio">
                      {
                        selectParticipantIndex === index && (
                          <span className="radio-dot"/>
                        )
                      }
                    </Col>
                    <Col lg="auto" className="noPadding userIcon w-auto">
                      <img
                        src={userIcon}
                        alt=""
                      />
                    </Col>
                    <Col className="noPadding userNameText overflowText" title={user}>
                      {user}
                    </Col>
                  </Row>
                ) : null;
              })
            }
          </div>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          <Button
            className="buttons btn-decline"
            onClick={()=>props.handleCancelClick()}
          >
            {getMessage("CANCEL")}
          </Button>
          <Button
            className="buttons btn-accept customBtn"
            onClick={()=>selectSnapchotParticipant()}
          >
            { getMessage("SELECTION")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  } else {
    return (
      <div className="menu-parent">
        <Menu
          slide
          right
          isOpen={props.popoverOpen}
          onStateChange={e => (!e.isOpen ? props.handleCancelClick() : null)}
          disableOverlayClick={() => console.log()}
        >
          {/* displaying modules */}
          <>
            <div className="modules">
              {props.renderModules(true)}
            </div>
          </>
        </Menu>
      </div>
    );
  }
}

Participants.propTypes = {
  participants: PropTypes.array,
  mobileView: PropTypes.bool,
  popoverOpen: PropTypes.bool
};
export default Participants;
